export default function TextInput({
  label = null,
  type = "text",
  value,
  setValue,
  name,
  placeholder,
  required = true,
  enabled = true,
  className = "",
  // error;
}) {
  return (
    <div className={`${className} `}>
      {label && (
        <label
          htmlFor={name}
          className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
        >
          {label}
        </label>
      )}
      <input
        disabled={!enabled}
        type={type}
        name={name}
        id={name}
        value={value}
        onChange={setValue}
        className="focus:ring-primary-600 focus:border-primary-600 block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-gray-900 dark:border-gray-600 dark:bg-gray-600 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500 sm:text-sm"
        placeholder={placeholder}
        required={required}
      />
    </div>
  );
}
